class IbscentFeaturedSlider extends HTMLElement {
  connectedCallback() {
    this.initWhenReady();
  }

  initWhenReady() {
    if (typeof BlazeSlider === 'function') {
      this.init();
      return;
    }
    const start = Date.now();
    const interval = setInterval(() => {
      if (typeof BlazeSlider === 'function') {
        clearInterval(interval);
        this.init();
      } else if (Date.now() - start > 4000) {
        clearInterval(interval);
      }
    }, 50);
  }

  init() {
    const root = this.querySelector('.blaze-slider');
    if (!root || this.slider) return;
    const desktop = parseFloat(this.dataset.slidesDesktop) || 3;
    const tablet = parseFloat(this.dataset.slidesTablet) || 2;
    const mobile = parseFloat(this.dataset.slidesMobile) || 1.2;
    this.slider = new BlazeSlider(root, {
      all: {
        enableAutoplay: false,
        slidesToShow: desktop,
        slideGap: '24px',
        loop: true,
        draggable: true,
        transitionDuration: 400,
        slidesToScroll: 1,
      },
      '(max-width: 960px)': {
        slidesToShow: tablet,
        slideGap: '16px',
      },
      '(max-width: 640px)': {
        slidesToShow: 1.3,
        slideGap: '12px',
      },
    });
  }
}

if (!customElements.get('ibscent-featured-slider')) {
  customElements.define('ibscent-featured-slider', IbscentFeaturedSlider);
}
